export class TagEntity {
  /**
   * id (string/number): A unique identifier for the tag.
   */
  id: number;
  /**
   * name (string): The name of the tag (e.g., "movement", "insertion", "deletion").
   */
  name: string;
  /**
   * description (string, optional): A brief description of the tag.
   */
  description?: string;
  /**
   * category (string, optional): A higher-level category for the tag (e.g., "Basic", "Advanced", "Commands").
   */
  category?: string;

  constructor(
    id: number,
    name: string,
    description?: string,
    category?: string
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.category = category;
  }
}
